import { Alert, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { useStore } from "react-redux";

import { DetailEdelmetall, DetailSorten, Lieferadresse } from "./components";
import { AUFTRAG_STATUS } from "../utils/enums";
import { formatBoolean } from "../utils/functions";

const AuftragDetails = (props) => {
  const { auftragStorage } = useStore().getState();
  const { configStorage } = useStore().getState();
  const auftrag = auftragStorage.getAuftrag();
  if (!auftrag && !auftragStorage.getError()) return (
    <Spinner animation="border" role="status" variant="primary">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
  if (!auftrag || !auftrag.auftragsNummer) {
    return <Alert variant="danger">{auftragStorage.getError() || "Fehler: Keine Auftragsnummer vorhanden"}</Alert>;
  }
  let detail;
  if (String(auftrag.geschaeftsart).match(/^so/)) {
    detail = <DetailSorten auftrag={auftrag} />;
  } else if (String(auftrag.geschaeftsart).match(/^em/)) {
    detail = <DetailEdelmetall auftrag={auftrag} />;
  } else {
    detail = <div>Für die Geschäftsart {auftrag.geschaeftsart} können keine Details angezeigt werden</div>;
  }
  const isVerkauf = !!String(auftrag.geschaeftsart).match(/VK$/);
  const isKnownGeschaeftsart = !!String(auftrag.geschaeftsart).match(/^(em|so)(AK|VK)$/);

  const auftragStatus = Object.keys(AUFTRAG_STATUS).filter(key => AUFTRAG_STATUS[key].KEY === auftrag.auftragsStatus)
    .map(key => AUFTRAG_STATUS[key].BEZEICHNUNG + " (" + auftrag.auftragsStatus + ")").join();

  const direktversand = auftrag.direktversandKz === "J";
  const versendet = direktversand ? "Kunde" : "Geschäftspartner";
  const bearbeiter = auftrag.bearbeiter || {};
  const besteller = auftrag.besteller || {};
  const auftragsDetails = auftrag.auftragsDetails || {};

  return <Container>
    <Card>
      <Card.Header>Bearbeiter</Card.Header>
      <Card.Body>
        <Row>
          <Col>Name:</Col><Col className="nowrap">{bearbeiter.name}</Col>
          {!configStorage.isDeuBa() ?
            <>
            <Col>Telefonnummer:</Col><Col className="nowrap">{bearbeiter.telefon}</Col>
            <Col>Beraterplatz:</Col><Col className="nowrap">{bearbeiter.platz}</Col>
            </>
          : 
            <>
            <Col></Col><Col className="nowrap"></Col>
            <Col></Col><Col className="nowrap"></Col>
            </>}
        </Row>
      </Card.Body>
    </Card>
    <Row>
      <Col sm="12" md="6">
        {detail}
      </Col>
      <Col>
        <Card className="h-100">
          <Card.Header>Kunde</Card.Header>
          <Card.Body>
            <Row>
              <Col sm="6" md="5" lg="4">Name:</Col><Col>{besteller.kundenname1}</Col>
            </Row>
            {String(besteller.kundenname2).trim() > ""
              ? <Row>
                <Col sm="6" md="5" lg="4" className="nowrap">Namens&shy;zusatz:</Col><Col>{besteller.kundenname2}</Col>
              </Row>
              : null
            }
            <Row>
              <Col sm="6" md="5" lg="4">Straße:</Col><Col>{besteller.kundenStrasse1}</Col>
            </Row>
            {String(besteller.kundenStrasse2).trim() > ""
              ? <Row>
                <Col sm="6" md="5" lg="4" className="nowrap">Straßen&shy;zusatz:</Col><Col>{besteller.kundenStrasse2}</Col>
              </Row>
              : null
            }
            <Row>
              <Col sm="6" md="5" lg="4">PLZ / Ort:</Col><Col>{besteller.plz} {besteller.kundeOrt}</Col>
            </Row>
            <Row>
              <Col sm="6" md="5" lg="4">Mitarbeiter:</Col><Col>{formatBoolean(auftragsDetails.mitarbeiterKz)}</Col>
            </Row>
            <Row>
              <Col sm="6" md="5" lg="4">Beratung:</Col><Col>{formatBoolean(auftragsDetails.beratungKz)}</Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
    <Card>
      <Card.Header>Auftragsdaten</Card.Header>
      <Card.Body>
        <Row>
          <Col md="6">
            <Row>
              <Col md="6" lg="4" className="nowrap">Auftragsstatus:</Col><Col>{auftragStatus}</Col>
            </Row>
            <Row>
              <Col md="6" lg="4" className="nowrap">Kunden-Konto:</Col><Col>{auftragsDetails.kundenKonto}</Col>
            </Row>
            <Row>
              <Col md="6" lg="4" className="nowrap">Kunden-Telefon:</Col><Col>{auftragsDetails.kundenTelefon}</Col>
            </Row>
          </Col>
          {isKnownGeschaeftsart
            ? <Col>
              <Row>
                {isVerkauf
                  ? <>
                    <Col md="6" lg="4" className="nowrap">Versand an:</Col>
                    <Col>{versendet}</Col>
                  </>
                  : <>
                    <Col md="12" lg="4" className="nowrap">Angeliefert bei:</Col>
                    <Col><Lieferadresse adressennummer={besteller.lieferadressennummer} name={besteller.lieferfilialadresse} /></Col>
                  </>
                }
              </Row>
              {isVerkauf
                ? <Row>
                  <Col md="12" lg="4" className="nowrap">Lieferadresse:</Col>
                  <Col>{direktversand
                    ? <div>
                      <span>
                        {String(besteller.kundenStrasse1).trim()}
                        {String(besteller.kundenStrasse2).trim()}
                      </span>
                      , <span>{besteller.plz} {besteller.kundeOrt}</span>
                    </div>
                    : <Lieferadresse adressennummer={besteller.lieferadressennummer} name={besteller.lieferfilialadresse} />
                  }
                  </Col>
                </Row>
                : null
              }
            </Col>
            : null
          }
        </Row>
        <Row>
          <Col lg="2" className="nowrap">Auftragstext:</Col><Col>{auftragsDetails.auftragstext}</Col>
        </Row>
      </Card.Body>
    </Card>
  </Container >;
};
export default AuftragDetails;
